const { getOffsetTop } = window.BAO.Utils

class FooterBackground extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setOverlayOpacity()
  }

  setOverlayOpacity () {
    if (!this.offsetHeight) return

    const minOpacityTop = 0.1
    const maxOpacityTop = 0.4

    const minOpacityBottom = 0.3
    const maxOpacityBottom = 0.8

    const minBlur = 5
    const maxBlur = 10

    const elementHeight = this.offsetHeight
    const elementStartPoint = getOffsetTop(this) - window.innerHeight / 2
    const elementEndPoint =
      getOffsetTop(this) + elementHeight - window.innerHeight

    let progress

    if (this.lastKnownY <= elementStartPoint) {
      progress = 0
    } else if (this.lastKnownY > elementEndPoint) {
      progress = 1
    } else {
      const totalScrollAmount = elementEndPoint - elementStartPoint
      progress = (this.lastKnownY - elementStartPoint) / totalScrollAmount
    }

    const opacityTop =
      minOpacityTop + (maxOpacityTop - minOpacityTop) * progress
    const opacityBottom =
      minOpacityBottom + (maxOpacityBottom - minOpacityBottom) * progress
    this.els.overlay.element.style.setProperty(
      '--OverlayOpacityTop',
      opacityTop,
    )
    this.els.overlay.element.style.setProperty(
      '--OverlayOpacityBottom',
      opacityBottom,
    )

    const blurAmount = minBlur + (maxBlur - minBlur) * progress
    this.els.overlay.element.style.setProperty(
      '--OverlayBlur',
      `${blurAmount}px`,
    )
  }
}

if (!customElements.get('footer-background')) {
  customElements.define('footer-background', FooterBackground)
}
